import React, { PropTypes } from 'react';
import { pointId } from '../reducers/point';
import ZonePointItem from './ZonePointItem';

const ZonePointList = ({ points, onDisplayPoint }) => (
  <div className="markers">
    {points.map(p => (
      <ZonePointItem key={pointId(p)} point={p} onDisplay={onDisplayPoint} />
    ))}
  </div>
);

ZonePointList.propTypes = {
  points: PropTypes.array.isRequired,
  onDisplayPoint: PropTypes.func.isRequired,
  taskType: PropTypes.string.isRequired,
};

export default ZonePointList;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/components/ZonePointList.js